// Pictures for the cakes the website sells (the names and descriptions are in
// translations/home: menu.items.<id>; prices come from the server).
import caramelCake from "assets/slider/caramelCake.jpg";
import plainCake from "assets/slider/plainCake.jpg";
import butterCaramelCake from "assets/slider/butterCaramelCake.jpeg";
import customCake from "assets/slider/customCake.jpeg";
import garamMasala from "assets/Garam-Masala.jpg";

// AI pictures (Gemini) of the Christmas cakes, shared by every cake that looks
// the same. Butter and ground spice don't show in a picture; caramel and cocoa
// give the colour (the "look"), and each fruit has its own slice picture:
// <look>-loaf, <look>-foil, <look>-slices-<none|mixed|kaju|...>.jpg
const shopPictures = require.context("assets/shop", false, /\.jpg$/);
const picture = (name) => {
  const file = `./${name}.jpg`;
  return shopPictures.keys().includes(file) ? shopPictures(file) : null;
};

// The first cakes on the list have their own set, real photo first.
const OWN_PICTURES = {
  "xmas-normal-caramel-mixed-nospice-nococoa": [
    caramelCake,
    "caramel-fruit-board",
    "caramel-slices-mixed",
    "caramel-fruit-tray",
  ],
  "xmas-normal-plain-none-nospice-nococoa": [
    plainCake,
    "plain-board",
    "plain-slices-none",
    "plain-tray",
  ],
  "xmas-butter-caramel-mixed-nospice-nococoa": [
    butterCaramelCake,
    "butter-caramel-fruit-board",
    "butter-caramel-fruit-slices",
    "butter-caramel-fruit-tray",
  ],
  "xmas-butter-plain-none-nospice-nococoa": [
    "butter-plain-board",
    "butter-plain-slices",
    "butter-plain-tray",
  ],
  "xmas-normal-caramel-none-nospice-nococoa": [
    "caramel-board",
    "caramel-slices-none",
    "caramel-tray",
  ],
};

// Up to 4 pictures for a Christmas cake (xmas-butter-caramel-kaju+walnut-spice-cocoa):
// a slice for each of its fruits, the whole loaf, the foil tray and the spice.
export function cakePictures(itemId) {
  if (OWN_PICTURES[itemId])
    // a name from assets/shop, or an imported photo (already its address)
    return OWN_PICTURES[itemId].map((p) => (p.includes("/") ? p : picture(p)));
  const [, , caramel, fruit, spice, cocoa] = (itemId || "").split("-");
  if (!fruit) return [];
  const look = `${caramel === "caramel" ? "caramel" : "plain"}${cocoa === "cocoa" ? "-cocoa" : ""}`;
  const slices = fruit.split("+").map((f) => `${look}-slices-${f}`);
  const names = [slices[0], `${look}-loaf`, ...slices.slice(1), `${look}-foil`];
  const pictures = names.map(picture).filter(Boolean);
  // the spice after the fruits: with 3-4 fruits it doesn't fit
  if (spice === "spice") pictures.splice(slices.length + 1, 0, garamMasala);
  return pictures.slice(0, 4);
}

const ITEM_IMAGES = { caramelCake, plainCake, butterCaramelCake, customCake };

// One picture for an item on the shop, the cart or a Christmas cake.
export const shopImage = (itemId) =>
  ITEM_IMAGES[itemId] || cakePictures(itemId)[0] || null;

export const WHATSAPP_SHOP = "919031392958";

export const formatRupees = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

// A Christmas cake's name from its id (xmas-butter-caramel-kaju-spice-cocoa),
// in the visitor's language. t is the "shop" translator.
export const isChristmasCake = (itemId) => /^xmas-/.test(itemId || "");
export function christmasCakeName(itemId, t, options) {
  const [, kind, caramel, fruit, spice, cocoa] = itemId.split("-");
  const name = (key) => t(`buy.name.${key}`, options);
  const extras = [
    kind === "butter" && name("butter"),
    !["none", "mixed"].includes(fruit) &&
      (fruit.includes("+")
        ? fruit
            .split("+")
            .map((one) => t(`buy.filter.${one}`, options))
            .join(" + ")
        : name(fruit)),
    spice === "spice" && name("spice"),
    cocoa === "cocoa" && name("cocoa"),
  ].filter(Boolean);
  const main = name(
    `${fruit === "none" ? "plain" : "fruit"}${caramel === "caramel" ? "Caramel" : ""}`,
  );
  return extras.length ? `${main} - ${extras.join(", ")}` : main;
}
